import AssessmentsAdapter from './base';

export default class Category extends AssessmentsAdapter {
  modelNamePlural = 'categories';
}
